import InviteToPay from './InviteToPay';

export default InviteToPay;